import { render, staticRenderFns } from "./DrayageButtonsAcceptance.vue?vue&type=template&id=da89db86&scoped=true"
import script from "./DrayageButtonsAcceptance.vue?vue&type=script&lang=js"
export * from "./DrayageButtonsAcceptance.vue?vue&type=script&lang=js"
import style0 from "./DrayageButtonsAcceptance.vue?vue&type=style&index=0&id=da89db86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da89db86",
  null
  
)

export default component.exports